import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/** 僅 DRAFT。後端 mutation-routes 為 PATCH。 */
export async function updateStockIssue(id, payload) {
  const { data: raw } = await request.patch(
    `/ims/stock-issue/${id}`,
    keysToSnake(omitTopLevelId(payload)),
  );
  return parseVer4DetailResponse(raw);
}
